// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2WY3D","rootCenter":"LoadMoreObserver_rootCenter__1tnFZ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1HhWI"};